export const settingsTabs = {
  storeSettings: 'storesettings',
  checkoutRates: 'checkoutrates',
  branding: 'branding',
  trackingPage: 'trackingpage',
  returns: 'returns',
  brandedEmails: 'emails',
  packingSlips: 'packingslips',
  products: 'products',
  shippingServices: 'shippingservices',
  activity: 'activity',
};
